export function saveQuoteToCreateData(quote) {
	localStorage.setItem('quote_to_create_data', JSON.stringify(quote));
}

export function getQuoteToCreateData() {
	const qtr = localStorage.getItem('quote_to_create_data');
	return JSON.parse(qtr);
}

export function saveCreatedQuotesNumbers(quotesNumbers) {
	const json = JSON.stringify(quotesNumbers);
	localStorage.setItem('created_quotes_numbers', json);
}

export function getCreatedQuotesNumbers() {
	const json = localStorage.getItem('created_quotes_numbers');
	return JSON.parse(json);
}

export function saveDiscountsData(data) {
	localStorage.setItem('discounts_data', JSON.stringify(data));
}
